import { useSetAtom } from 'jotai'
import { useSearchParams } from 'react-router-dom'
import { getChainByName } from 'src/common/utils/web3/network'
import {
  useActiveWalletConnectionStatus,
  useSwitchActiveWalletChain,
} from 'thirdweb/react'
import { lastChainIdAtom } from '../../stores/store'
import useEffectCompare from '../helpers/useEffectCompare'
import useActiveOrDefaultChain from './useActiveOrDefaultChain'
import { useEffect } from 'react'

const useHandleSwitchChain = () => {
  const chain = useActiveOrDefaultChain()
  const setLastChainId = useSetAtom(lastChainIdAtom)
  const [searchParams] = useSearchParams()
  const switchChain = useSwitchActiveWalletChain()

  const status = useActiveWalletConnectionStatus()

  const chainNameSearchParam = searchParams.get('chain')
  const chainBySearchParam =
    chainNameSearchParam && getChainByName(chainNameSearchParam)

  useEffect(() => {
    const handleChainChange = async () => {
      if (status === 'connected') {
        await switchChain(chain)
      }

      if (chainBySearchParam) {
        {
          setLastChainId(chainBySearchParam?.id)
        }
      }
    }
    handleChainChange()
  }, [status])

  useEffectCompare(() => {
    setLastChainId(chain.id)
    window.location.reload()
  }, [chain.id])
}

export default useHandleSwitchChain
